export const URL = '/api/product'
